var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateEventPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49989 10.5V7.5M7.49989 7.5V4.5M7.49989 7.5H4.49994M7.49989 7.5H10.4998M0.5 11.3002V3.7002C0.5 2.58009 0.5 2.01962 0.717983 1.5918C0.909727 1.21547 1.21546 0.909734 1.59178 0.717987C2.0196 0.5 2.58006 0.5 3.70015 0.5H11.3C12.4201 0.5 12.9799 0.5 13.4077 0.717987C13.784 0.909734 14.0903 1.21547 14.282 1.5918C14.5 2.01962 14.5 2.57969 14.5 3.69978V11.2998C14.5 12.4199 14.5 12.98 14.282 13.4078C14.0903 13.7841 13.784 14.0905 13.4077 14.2822C12.9803 14.5 12.4213 14.5 11.3034 14.5H3.69686C2.57896 14.5 2.01918 14.5 1.59178 14.2822C1.21546 14.0905 0.909728 13.7842 0.717984 13.4079C0.5 12.9801 0.5 12.4203 0.5 11.3002Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEventPlus);
export default __webpack_public_path__ + "static/media/create-event-plus.48cdc2f71761db8e225651a49b905449.svg";
export { ForwardRef as ReactComponent };